(function () {
    'use strict';

    angular
        .module('components.claims', [
            'app.core'
        ]);

})();
